// src/modules/app-views/_apps/appmulti/orders/pages/Document/actions/dropdownMenu.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { MoreOutlined } from '@ant-design/icons';
import {
  dropdownArchive,
  dropdownDivider,
  dropdownRemove,
  dropdownRemovePermanently,
  dropdownRestore,
} from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// DROPDOWN MENU
// *******************************************************************************
const ordersDocumentDropdownMenu = () => ({
  action: 'dropdownMenu',
  icon: <MoreOutlined />,
  tooltip: 'more_options',
  dropdownItems: [
    dropdownDivider,
    dropdownArchive,
    dropdownRemove,
    dropdownRestore,
    dropdownRemovePermanently,
  ],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ordersDocumentDropdownMenu;
